module.exports = __webpack_public_path__ + "media/images/gift/steps/credit_card-a069cb33f40a9a57cfa21081a657bb19.png";